import { render, staticRenderFns } from "./ChatVideo.vue?vue&type=template&id=60bfabb6&scoped=true"
import script from "./ChatVideo.vue?vue&type=script&lang=js"
export * from "./ChatVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bfabb6",
  null
  
)

export default component.exports